import type { Route } from 'next';
import Link from 'next/link';
import type { Faq, FaqCategory } from '../../types';
import styles from './FaqList.module.scss';
import raffleStyles from './FaqList.raffle.module.scss';

export interface FaqListProps {
  items: Array<FaqCategory>;
  FaqTagListComponent: React.ComponentType<{
    items: Array<{
      child: React.ReactNode;
      href?: Route;
    }>;
  }>;
  variant?: 'default' | 'raffle';
}

function FaqList({ items, FaqTagListComponent, variant = 'default' }: FaqListProps) {
  // variantに応じてスタイルを決定
  const currentStyles = variant === 'raffle' ? raffleStyles : styles;

  const faqItemList = (faqItemList: Array<Faq>) => {
    return (
      <ul className={currentStyles.faqs}>
        {faqItemList.map((faq) => (
          <li key={`faq_${faq.id}`}>
            <h3 className={currentStyles.faqTitle}>
              <Link href={`/faq/${faq.id}` as Route} data-testid={`faq-link-${faq.title}`}>
                {faq.title}
              </Link>
            </h3>
            <FaqTagListComponent
              items={faq.tags.map((tag) => ({
                child: <>#{tag.name}</>,
                href: `/faq?faqTagId=${tag.id}` as Route,
              }))}
            />
          </li>
        ))}
      </ul>
    );
  };

  return (
    <main data-testid='faq-main'>
      <ul className={currentStyles.faqList}>
        {items.map((category, index) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
          <li key={index}>
            <h2 className={currentStyles.sectionTitle} data-testid='search-result-heading'>
              {category.faqCategoryName}
            </h2>
            {faqItemList(category.faq)}
          </li>
        ))}
      </ul>
    </main>
  );
}

export default FaqList;
